(function() {
  var busy = new WeakSet();

  function findAvailableSizeVariant(product, wantedColor) {
    if (!product || !product.variants) return null;
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (!v.available) continue;
      if (wantedColor) {
        var hasColor = (v.options || []).some(function(o) { return String(o).toLowerCase() === String(wantedColor).toLowerCase(); });
        if (!hasColor) continue;
      }
      return v;
    }
    return product.variants.find(function(v) { return !wantedColor || (v.options || []).some(function(o) { return String(o).toLowerCase() === String(wantedColor).toLowerCase(); }); }) || null;
  }

  async function fetchCart() {
    try {
      var res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!res.ok) return null;
      return res.json();
    } catch (e) { return null; }
  }

  function notifyCartUpdated(cart, sourceId) {
    // Horizon listens for 'cart:update' (ThemeEvents.cartUpdate) with bubbles
    // and reads event.detail.resource for cart data. Firing on document +
    // bubbling from any element covers all listener attachment styles.
    var evt = new CustomEvent('cart:update', {
      bubbles: true,
      detail: { resource: cart || null, sourceId: sourceId || 'sr-quick-add', data: {} }
    });
    document.dispatchEvent(evt);
    // Also fire on window in case a listener uses that surface
    window.dispatchEvent(new CustomEvent('cart:update', { detail: { resource: cart || null } }));
  }

  function openDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer) {
      // Ensure auto-open is on so any subsequent CartAddEvent opens it too
      drawer.setAttribute('auto-open', '');
      if (typeof drawer.open === 'function') { try { drawer.open(); return; } catch (e) {} }
      if (typeof drawer.showDialog === 'function') { try { drawer.showDialog(); return; } catch (e) {} }
    }
    var trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (trigger) trigger.click();
  }

  async function addToCart(variantId) {
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    });
    if (!res.ok) throw new Error('Failed to add to cart (' + res.status + ')');
    return res.json();
  }

  async function fetchProductJson(handle) {
    var res = await fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } });
    if (!res.ok) throw new Error('Failed to fetch product ' + handle);
    return res.json();
  }

  async function handleClick(btn) {
    if (busy.has(btn)) return;
    busy.add(btn);
    var origText = btn.textContent;
    btn.textContent = 'ADDING...';
    btn.setAttribute('disabled', 'disabled');

    try {
      var color = btn.getAttribute('data-color');
      var handle = btn.getAttribute('data-product-handle');
      var defaultVariantId = btn.getAttribute('data-default-variant-id');
      var variantId = defaultVariantId;

      if (handle) {
        try {
          var product = await fetchProductJson(handle);
          var v = findAvailableSizeVariant(product, color);
          if (v) variantId = v.id;
        } catch (e) { /* fall back to default variant */ }
      }

      await addToCart(variantId);
      var cart = await fetchCart();
      notifyCartUpdated(cart, btn.id || 'sr-quick-add');
      openDrawer();

      btn.textContent = 'ADDED ✓';
      setTimeout(function() { btn.textContent = origText; btn.removeAttribute('disabled'); busy.delete(btn); }, 1400);
    } catch (e) {
      btn.textContent = 'TRY AGAIN';
      setTimeout(function() { btn.textContent = origText; btn.removeAttribute('disabled'); busy.delete(btn); }, 1600);
    }
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-cx-quick-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    handleClick(btn);
  });
})();
